import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

/**
 * Wrappers de navegación conscientes del locale.
 *
 * IMPORTANTE: en cualquier componente, importá `Link`, `useRouter`, etc. DESDE ACÁ,
 * nunca desde `next/link` o `next/navigation`. Así el prefijo de locale se agrega
 * solo y los links no rompen el idioma activo.
 *
 *   import { Link } from "@/i18n/navigation";
 *   <Link href="/app">...</Link>   // => /es/app o /en/app según el locale
 */
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
